const UPDATE_SVG = 'UPDATE_SVG';

function updateSvg(svgType, id, svgString) {
  return { type: UPDATE_SVG, svgType, id, svgString };
}

function update(state, svgType, id, svgString) {
  return {
    ...state,
    [svgType]: {
      ...state[svgType],
      [id]: svgString,
    },
  };
}

export { UPDATE_SVG, updateSvg, update };
